<ng-container *transloco="let convert;">
  <div class="edit-posting-form">
    <h3 class="content-card-title">{{convert('sellModule.posting.descriptionForm.textBasicInfo')}}</h3>
    <div class="content-card-subtitle">{{convert('sellModule.posting.descriptionForm.textUseDropDown')}}</div>

    @if (fetchVinDecodeInProgress) {
      <div class="loader-container">
        <app-spinner></app-spinner>
      </div>
    }
    @if (!fetchVinDecodeInProgress) {
      <form class="body" name="descriptionForm" [formGroup]="descriptionForm" nonvalidate>
        <div class="container">
          <div class="row mt-2">
            <div class=label>
              <label>{{convert('sellModule.posting.descriptionForm.labelKeyDetails')}}</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="trim">{{convert('sellModule.posting.descriptionForm.labelTrim')}}</label>
              <div class="select-wrapper">
          <select formControlName="trim" id="trim" (change)="trackFormChanges('trim')" [ngClass]="isTrimDisabled() ? 'custom-select wrapText disabled-control form-control' :showTrimError()
          ? 'custom-select wrapText is-invalid' :'custom-select'" [attr.aria-required]="!isTrimDisabled()"
                  [attr.aria-label]="'Trim select'">
                  <option [ngValue]="'default'">{{trimPlaceholder}}</option>
                  @for (vtOption of vehicleTrimOption; track vtOption) {
                    <option [ngValue]="vtOption.vehicleTrimName">
                    {{vtOption.vehicleTrimName}}</option>
                  }
                </select>
              </div>
              @if (!isTrimDisabled() && showTrimError()) {
                <span class="required-item-error-message">
                  {{convert('sellModule.posting.descriptionForm.textSelectTrim')}}
                </span>
              }
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="vehicleType">{{convert('sellModule.posting.descriptionForm.labelVehicleType')}}</label>
              <div class="select-wrapper">
                <select formControlName="vehicleType" id="vehicleType"
                  [ngClass]="showVehicleTypeError() ? 'custom-select wrapText is-invalid' :'custom-select wrapText'"
                  (change)="trackFormChanges()">
                  <option [ngValue]="'default'">{{convert('sellModule.posting.descriptionForm.textSelect')}}</option>
                  @if (vehicleTypes) {
                    @for (vhType of vehicleTypes; track vhType) {
                      <option [ngValue]="vhType.typeCode">({{vhType.typeCode}}) {{vhType.typeDescription}}</option>
                    }
                  }
                </select>
              </div>
              @if (showVehicleTypeError()) {
                <span class="required-item-error-message">
                  {{convert('sellModule.posting.descriptionForm.vehicleTypeRequiredErrorMessage')}}
                </span>
              }
              @if (showBuyNowNotAllowedError) {
                <span>
                  <strong>{{convert('sellModule.posting.descriptionForm.textBuyNowNotAllowed')}}</strong>
                </span>
              }
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="titleState">{{descriptionFormTranslations.labelTitleStateOrProvince}}</label>
              <div class="select-wrapper">
                <select formControlName="titleState" id="titleState" class="custom-select wrapText" (change)="trackFormChanges()">
                  @for (stateProvince of statesProvincesList; track stateProvince) {
                    <option [ngValue]="stateProvince.abbr">{{stateProvince.name}}</option>
                  }
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="stockOrAccount">{{convert('sellModule.posting.descriptionForm.labelStockOrAcc')}}</label>
              <input name="stockOrAccount"
                id="stockOrAccount"
                class="form-control spread__input"
                maxlength="12"
                formControlName="stockOrAccount"
                [attr.aria-label]="convert('sellModule.posting.descriptionForm.labelStockOrAcc')"
                (input)="restrictFormCharacters()"
                (change)="trackFormChanges()" />
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row mt-2">
            <div class=label>
              <label>{{descriptionFormTranslations.labelExteriorInterior}}</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="odometerMiles">{{descriptionFormTranslations.labelOdometer}}</label>
              <input
                type='text'
                name="odometerMiles" id="odometerMiles" class="form-control spread__input"
                formControlName="odometerMiles"
                [attr.aria-label]="convert('sellModule.posting.descriptionForm.labelOdometerMiles')"
                (blur)="trackFormChanges()"
                [class.is-invalid]="!isOdometerValid"
                mask="separator.0"
                thousandSeparator=","
                separatorLimit="1000000"
                [allowNegativeNumbers]="false"/>
              @if (!isOdometerValid) {
                <span class="required-item-error-message">
                  {{convert('sellModule.posting.descriptionForm.odometerRequiredErrorMessage')}}
                </span>
              }
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="exteriorColor">{{descriptionFormTranslations.labelExterior.toUpperCase()}} {{descriptionFormTranslations.color.toUpperCase()}}</label>
              <div class="select-wrapper">
                <select formControlName="exteriorColor" id="exteriorColor" class="custom-select wrapText" (change)="trackFormChanges()">
                  <option [ngValue]="'default'">{{convert('sellModule.posting.descriptionForm.textSelect')}}</option>
                  @for (exteriorColorOption of exteriorColorOptions; track exteriorColorOption) {
                    <option [ngValue]="exteriorColorOption.colorCode">
                    {{exteriorColorOption.shortDescription}}</option>
                  }
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="interiorType">{{convert('sellModule.posting.descriptionForm.labelInteriorType')}}</label>
              <div class="select-wrapper">
                <select formControlName="interiorType" id="interiorType" class="custom-select wrapText" (change)="trackFormChanges()">
                  <option [ngValue]="'default'">{{convert('sellModule.posting.descriptionForm.textSelect')}}</option>
                  @for (interiorTypeOption of interiorTypes; track interiorTypeOption) {
                    <option [ngValue]="interiorTypeOption.optionCode">
                    {{interiorTypeOption.userFriendlyDescription}}</option>
                  }
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="interiorColor">{{descriptionFormTranslations.labelInterior.toUpperCase()}} {{descriptionFormTranslations.color.toUpperCase()}}</label>
              <div class="select-wrapper">
                <select formControlName="interiorColor" id="interiorColor" class="custom-select wrapText" (change)="trackFormChanges()">
                  <option [ngValue]="'default'">{{convert('sellModule.posting.descriptionForm.textSelect')}}</option>
                  @for (interiorColorOption of interiorColorOptions; track interiorColorOption) {
                    <option [ngValue]="interiorColorOption.colorCode">
                    {{interiorColorOption.shortDescription}}</option>
                  }
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row mt-2">
            <div class="form-group ps-0">
              <label>{{convert('sellModule.posting.descriptionForm.labelCommercialVehicle')}}</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mb-3">
            <div class="custom-control custom-radio custom-control-inline ">
              <input type="radio" id="neitherCheckBox" name="vehicleUse" class="custom-control-input"
                formControlName="vehicleUse" value="Neither" (change)="trackFormChanges()"/>
              <label class="custom-control-label" for="neitherCheckBox">{{convert('sellModule.posting.descriptionForm.labelNeither')}}</label>
            </div>
          </div>
          <div class="col-md-12 mb-3">
            <div class="custom-control custom-radio custom-control-inline ">
              <input type="radio" id="commercialCheckBox" name="vehicleUse" class="custom-control-input"
                formControlName="vehicleUse" value="Commercial" (change)="trackFormChanges()"/>
              <label class="custom-control-label" for="commercialCheckBox">{{convert('sellModule.posting.descriptionForm.labelCommercial')}}</label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="custom-control custom-radio custom-control-inline ">
              <input type="radio" id="recreationalCheckBox" name="vehicleUse" class="custom-control-input"
                formControlName="vehicleUse" value="Recreational" (change)="trackFormChanges()"/>
              <label class="custom-control-label" for="recreationalCheckBox">{{convert('sellModule.posting.descriptionForm.labelRecreational')}}</label>
            </div>
          </div>
        </div>
        @if (postingNoteParam) {
          <div class="container posting-note ps-0">
            <div class="row mt-2">
              <label [innerHTML]="convert('sellModule.posting.descriptionForm.' + postingNoteParam)"></label>
            </div>
          </div>
        }
      </form>
    }
  </div>

  <app-modal tabindex="-1" [modalId]="'trimChangeModal'">
    @if (!chromeResponseInProgress) {
      <div class="modal-close-container">
        <button
          class="modal__close"
          [attr.aria-label]="convert('common.modalClose')"
          (click)="cancel()"
          >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
    }

    @if (!chromeResponseInProgress) {
      <header class="modal__header">
        <h1 class="modal__title text-brand" tabindex="-1" aria-hidden="true" [innerHTML]=
          "convert('sellModule.posting.descriptionForm.textTrimChangeConfirmationMessage')">
        </h1>
      </header>
    }

    <div class="modal__content" >
      @if (chromeResponseInProgress) {
        <div class="loader-container">
          <app-spinner></app-spinner>
        </div>
      }
      @if (!chromeResponseInProgress) {
        <div class="modal__body">
          <p>
            {{convert('sellModule.posting.descriptionForm.trimChangeNote')}}
          </p>
          <br>
            @if (!chromeResponseInProgress) {
              <div class="modal__actions">
                <button
                  class="btn btn-primary"
                  data-track-name="Yes, Continue"
                  (click)="continueWithChromeCall()"
                  [attr.aria-label]="convert('common.btnYesContinue')">
                  {{convert('common.btnYesContinue')}}
                </button>
                <button
                  class="btn cancel btn-link outline-focus"
                  data-track-name="Cancel"
                  (click)="cancel()"
                  [attr.aria-label]="convert('common.btnCancel')">
                  {{convert('common.btnCancel')}}
                </button>
              </div>
            }
          </div>
        }
      </div>
    </app-modal>
    <app-error-modal></app-error-modal>
  </ng-container>
